module.exports = __webpack_public_path__ + "iPadGuide1@2x.e9be4be7.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/iPadGuide1@2x.png
// module id = bjIW
// module chunks = 0